module.exports = __webpack_public_path__ + "static/img/new1.697454d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new1.jpg
// module id = YRPs
// module chunks = 1